require('./jv.search.collection-list-modal.directive.webpack.js');
require('../../common/directives/jv.AjaxSelect');
require('../../common/directives/jv.Datepicker');
require('../../common/directives/jv.simple-select.directive');
require('../../common/directives/jv.typeahead.directive');
require('../../common/jv.EmployeeSelect');
require('../../common/jv.i18n');
require('./jv.search.filter-transforms.service');
require('../../common/jv.TextUtil');

angular.module('jv.search.filter.directive', [
    'jv.search.collection-list-modal.directive',
    'jv.Common.AjaxSelect',
    'jv.Common.Directives.Datepicker',
    'jv.simple-select.directive',
    'jv.common.typeahead.directive.js',
    'jv.Common.EmployeeSelect',
    'jv.Common.i18n',
    'jv.search.filter-transforms.service',
    'jv.Common.TextUtil',
    'ngStorage',
    // 'rzModule', // TODO: uncomment if we decide to use sliders
    'jv.Common.Filters',
    'jv.search.filter-transforms.service',
])
/*
    Directive: jv-search-filter

    expected dropdown structure:

    {
        "canSort": false,
        "defaultValue": null,
        "fieldId": null,
        "filterType": "DropDown",
        "name": "category",
        "values": [
            {
                "key": "apV9Vfw8",
                "value": "Administrative"
            }
        ]
    }

    expected range structure:

    {
        "canSort": false,
        "defaultValue": null,
        "fieldId": null,
        "filterType": "Range",
        "name": "category",
        "unit": {
            "singular": "month",
            "plural": "months"
        },
        options: {
            "floor": 0,
            "ceil": 30
        }
    }

 */
.directive('jvSearchFilter', [
    '$compile', 'jvSearchAjaxFilterTransform', 'TextUtil',
    function($compile, jvSearchAjaxFilterTransform, TextUtil) {
        var typeToDirectiveMap = {
            text: 'jv-text-filter',
            dropdown: 'jv-dropdown-filter',
            // ajax: 'jv-ajax-dropdown-filter',
            company: 'jv-company-filter',
            jobtitle: 'jv-job-title-filter',
            school: 'jv-school-filter',
            range: 'jv-range-filter',
            location: 'jv-location-filter',
            daterange: 'jv-date-range-filter',
            requisition: 'jv-requisition-filter',
            collection: 'jv-collection-filter',
            checkbox: 'jv-checkbox-filter',
            numberrange: 'jv-number-range-filter',
            source: 'jv-source-filter',
            employee: 'jv-employee-filter',
            currency: 'jv-currency-range-filter'
        };
        return {
            restrict: 'A',
            scope: {
                filter: '=jvSearchFilter',
                filterModel: '=',
                summaryChanged: '=',
                filterLoaded: '='
            },
            link: function(scope, element, attributes, model) {
                var filterType = scope.filter.filterType.toLowerCase();
                scope.filter.directive = typeToDirectiveMap[filterType];
                if (filterType === 'dropdown' && scope.filter.multiple) {
                    // need to have a separate directive for multiple select dropdowns because ng 1.2 doesn have ng-attr :(
                    scope.filter.directive = 'jv-multi-dropdown-filter';
                }
                if (filterType === 'dropdown') {
                    // all custom dropdowns should be ajax selects
                    scope.filter = jvSearchAjaxFilterTransform.transform(scope.filter);
                }
                if(filterType === 'currency'){
                    scope.filter.url = [jvUrls.jhire, 'action/application/field',scope.filter.searchId, 'values'].join('/');
                }
                if(filterType === 'checkbox' && scope.filter.values !== null && scope.filter.values.length>0){
                    scope.filter.values = TextUtil.decodeFieldValuesList(scope.filter.values);
                }
                if (scope.filter.directive) {
                    element.append($compile('<div ' + scope.filter.directive + ' filter="filter" filter-model="filterModel" on-summary-changed="summaryChanged(summary)" on-filter-loaded="filterLoaded()"></div>')(scope));
                }
            }
        }
    }
])
.factory('createFilter', [
    function() {
        return function(directive) {
            return angular.extend({
                restrict: 'A',
                scope: {
                    filter: '=',
                    filterModel: '=',
                    onSummaryChanged: '&',
                    onFilterLoaded: '&',
                    onFilterChange:'&'
                }
            }, directive);
        };
    }
])
.factory('createDropdownLinker', [
    '$timeout', 'i18n',
    function($timeout, i18n) {
        return function(isMultiple) {
            return function(scope, element) {

                function updateSummary(val) {
                    var summary = {
                        id: scope.filter.searchId,
                        hidden: scope.filter.hidden,
                        deleted: !val || (Array.isArray(val) && !val.length)
                    };
                    var label = '';
                    if (!summary.deleted) {
                        if(Array.isArray(scope.filter.values)){
                            if (Array.isArray(val)) {
                                label = scope.filter.values.filter(function(option) {
                                    return (val.indexOf(option.key) > -1);
                                }).map(function(option) {
                                    return option.value;
                                }).join(', ');
                            }
                            else {
                                label = scope.filter.values.filter(function(option) {
                                    return (option.key === val);
                                }).pop(0).value;
                            }
                        }
                        summary.message = scope.filter.name + ': ' + label;
                    }
                    scope.onSummaryChanged({ summary: summary });
                }

                function setDefaultValue(force) {
                    if (force || (scope.filter.defaultValue != null && !scope.filterModel)) {
                        if (isMultiple) {
                            scope.filterModel = [scope.filter.defaultValue];
                            if(scope.filter.defaultValue){
                                scope.filterModel = [scope.filter.defaultValue];
                            }else{
                                scope.filterModel = [];
                            }
                        } else {
                            scope.filterModel = scope.filter.defaultValue;
                        }

                    }
                }

                scope.$watch('filterModel', function(val) {
                    updateSummary(val);
                });

                scope.$on('resetFilter', function() {
                    $timeout(function() {
                        setDefaultValue(true);
                    });
                });

                scope.onFilterLoaded();
            };
        };
    }
])
.directive('jvTextFilter', [
    'createFilter',
    function(createFilter) {
        return createFilter({
            link: function(scope) {
                function updateSummary(val) {
                    var summary = {
                        id: scope.filter.searchId,
                        hidden: scope.filter.hidden,
                        deleted: !val
                    }
                    if (!summary.deleted) {
                        summary.message = scope.filter.name + ': ' + val;
                    }
                    scope.onSummaryChanged({ summary: summary });
                }
                scope.$watch('filterModel', updateSummary);
                scope.onFilterLoaded();
            },
            template: '<input type="text" ng-model="filterModel" class="full-width" />'
        });
    }
])
.directive('jvDropdownFilter', [
    'createFilter', 'createDropdownLinker', 'i18n',
    function(createFilter, createDropdownLinker, i18n) {
        return createFilter({
            link: createDropdownLinker(false),
            template: '<select simple-select="{ allowClear: true, placeholder: \'' + i18n.ANY + '\' }" ng-model="filterModel" class="full-width" ng-options="o.key as o.value for o in filter.values"><option></option></select>'
        });
    }
])
.directive('jvMultiDropdownFilter', [
    'createFilter', 'createDropdownLinker',
    function(createFilter, createDropdownLinker) {
        return createFilter({
            link: createDropdownLinker(true),
            template: '<select simple-select ng-model="filterModel" class="full-width" ng-options="o.key as o.value for o in filter.values" multiple></select>'
        });
    }
])
.directive('jvAjaxDropdownFilter', [
    'createFilter', '$timeout',
    function(createFilter, $timeout) {
        return createFilter({
            link: function(scope, element, attributes) {
                function updateSummary(val) {
                    var summary = {
                        id: scope.filter.searchId,
                        hidden: scope.filter.hidden,
                        deleted: !val || (Array.isArray(val) && !val.length)
                    }
                    var label = '';
                    if (!summary.deleted) {
                        if (Array.isArray(val)) {
                            label = val.map(function(elem) {
                                        return elem[scope.filter.value];
                                    }).join(", ");
                        }
                        summary.message = scope.filter.name + ': ' + label;
                    }
                    scope.onSummaryChanged({ summary: summary });
                }

                function updateUI(val) {
                    var select2 = element.find('[jv-ajax-select]');
                    if (!angular.equals(select2.select2('data'), val)) {
                        if (val) {
                            select2.select2('data', val);
                        }
                        else {
                            select2.select2('data', []);
                        }
                    }
                }

                scope.config = {
                    multiple: true
                };

                if (scope.filterModel) {
                    updateSummary(scope.filterModel);
                    $timeout(function() {
                        updateUI(scope.filterModel);
                    });
                }
                scope.updateModel = function(val) {
                    scope.filterModel = val;
                };
                scope.$watch('filterModel', function(val) {
                    //Required because when we have jv-ajax-select-object and if model is undefined, results in unexpected behavior.
                    if (!val) {
                        val = [];
                        scope.updateModel(val);
                    }
                    updateUI(val);
                    updateSummary(val);
                });
                scope.onFilterLoaded();
            },
            template: '<div ng-if="config" ng-hide="filter.hidden" jv-ajax-select-object jv-ajax-select-query-param-name="{{ filter.queryParamName }}" jv-ajax-select="config" jv-ajax-select-url="{{ filter.url }}" jv-ajax-select-response-key="{{ filter.resultList }}" jv-ajax-select-can-clear="true" jv-ajax-select-id="{{filter.key}}" jv-ajax-select-text="{{filter.value}}" jv-ajax-select-query-param-name="q" ng-model="filterModel" ng-change="updateModel(filterModel)" class="full-width"></div>'
        });
    }
])
.directive('jvCompanyFilter', [
    'createFilter','i18n','$timeout',
    function(createFilter, i18n, $timeout) {
        return createFilter({
            link: function(scope) {
            var url = '../../action/application/search/facet?fieldId=company';
            scope.companySelectPlaceholder = i18n['SELECT_COMPANIES'];
            var maxResults = 20;
            //range filter for company
            scope.companyRange = [
                    { value: 'all', label: i18n.CURRENT_OR_PAST },
                    { value: 'current', label:  i18n.CURRENT },
                    { value: 'past', label: i18n.PAST }
            ];
            function updateSummary() {
                var filterModel  = angular.copy(scope.filterModel);
                var summary = {
                    id: scope.filter.searchId,
                    hidden: scope.filter.hidden,
                    deleted: true
                };
                if(filterModel && filterModel.companyNames && filterModel.companyNames.length){
                    var companyNames = [];
                    angular.forEach(filterModel.companyNames,function(companyObj,key){
                        companyNames.push(companyObj.value);
                    });
                    summary.message = i18n['COMMON_COMPANY']+': ' + companyNames.join(', ');

                    if (filterModel.companyRange === 'current') {
                        summary.message += ' (' + i18n.CURRENT + ')';
                    }

                    if (filterModel.companyRange === 'past') {
                        summary.message += ' (' + i18n.PAST + ')';
                    }

                    summary.deleted =  false;
                }
                scope.onSummaryChanged({ summary: summary });
            }
            //company filter config
            scope.companyFilterConfig = {
                    id:'value',
                    ajax : {
                        url : url,
                        quietMillis: 750,
                        data : function (term, page) {
                                result = {
                                    prefix: term,
                                    maxResults: maxResults,
                                    page: page - 1,
                            };
                            return result;
                        },
                        results: function (data, page) {
                            //pagination not supported by BE
                            //var more = (maxResults * page) < data.facetField.facetValues.count;
                            var more = false;
                            return {
                                results: data.facetField.facetValues,
                                more: more
                            };
                        }
                    },
                    formatResult: function (company) {
                        return '<strong>' + company.value + '</strong> ';
                    },
                    formatSelection: function (company) {
                            return company.value;
                    },
                    initSelection: function(element, callback) {
                        //if filterModel is has predefined values that you want to load copy the filterModel object  and re-initialize it as select renders before filterModel gets the value so you need to re-set.
                        if(!$.isEmptyObject(scope.filterModel)){
                            var filterModelCopy = angular.copy(scope.filterModel);
                            scope.filterModel = {};
                            scope.filterModel = filterModelCopy;
                            if(!scope.filterModel.companyRange){
                                //initialize secondary company dropdown
                                scope.initCompanyDropdown();
                            }
                        }
                    }
                };
                //making sure config is ready before select2 renders
                $timeout(function(){
                    scope.showCompanyFilter = true;
                },300);

                var initCompanyFilterModel = function(){
                    scope.filterModel = {};
                };
                scope.initCompanyDropdown = function(){
                    if(scope.filterModel.companyNames && scope.filterModel.companyNames.length){
                        scope.filterModel.companyRange = scope.companyRange[0].value;
                    }
                };
                //todo fix the change event for range filter
                scope.$watch('filterModel',function(newVal, oldVal){
                    if(!newVal){
                        initCompanyFilterModel();
                    }
                    updateSummary();
                },true);
                scope.onFilterLoaded();
            },
            template: '<input ng-if="showCompanyFilter" data-placeholder="{{companySelectPlaceholder}}" style="width: 100%;" ui-select2="companyFilterConfig" ng-change="initCompanyDropdown()" multiple ng-model="filterModel.companyNames" class="full-width"></input> <select simple-select ng-show="filterModel.companyNames.length" ng-model="filterModel.companyRange"  ng-options="o.value as o.label for o in companyRange"  class="full-width margin-top-small"></select>'
        });
    }
])
.directive('jvJobTitleFilter', [
    'createFilter','i18n','$timeout',
    function(createFilter, i18n, $timeout) {
        return createFilter({
            link: function(scope) {
            var url = '../../action/application/search/facet?fieldId=jobTitles';
            scope.jobTitleSelectPlaceholder = i18n['SELECT_JOB_TITLES'];
            var maxResults = 20;
            function updateSummary() {
                var filterModel  = angular.copy(scope.filterModel);
                var summary = {
                    id: scope.filter.searchId,
                    hidden: scope.filter.hidden,
                    deleted: true
                };
                if(filterModel && filterModel.jobTitles && filterModel.jobTitles.length){
                    var jobTitles = [];
                    angular.forEach(filterModel.jobTitles,function(jobTitleObj,key){
                        jobTitles.push(jobTitleObj.value);
                    });
                    summary.message = i18n['COMMON_JOB_TITLE']+': ' + jobTitles.join(', ');
                    summary.deleted =  false;
                }
                scope.onSummaryChanged({ summary: summary });
            }
            //job title filter config
            scope.jobTitleFilterConfig = {
                    id:'value',
                    ajax : {
                        url : url,
                        quietMillis: 750,
                        data : function (term, page) {
                                result = {
                                    prefix: term,
                                    maxResults: maxResults,
                                    page: page - 1,
                            };
                            return result;
                        },
                        results: function (data, page) {
                            //pagination not supported by BE
                            //var more = (maxResults * page) < data.facetField.facetValues.count;
                            var more = false;
                            return {
                                results: data.facetField.facetValues,
                                more: more
                            };
                        }
                    },
                    formatResult: function (jobTitle) {
                        return '<strong>' + jobTitle.value + '</strong> ';
                    },
                    formatSelection: function (jobTitle) {
                            return jobTitle.value;
                    },
                    initSelection: function(element, callback) {
                        if(!$.isEmptyObject(scope.filterModel)){
                            var filterModelCopy = angular.copy(scope.filterModel);
                            scope.filterModel = {};
                            scope.filterModel = filterModelCopy;
                         }
                    }
                };
                //making sure config is ready before select2 renders
                $timeout(function(){
                    scope.showJobTitleFilter = true;
                },300);

                var initJobTitleFilterModel = function(){
                    scope.filterModel = {};
                };
                //todo fix the change event for range filter
                scope.$watch('filterModel',function(newVal, oldVal){
                    if(!newVal){
                        initJobTitleFilterModel();
                    }
                    updateSummary();
                },true);
                scope.onFilterLoaded();
            },
            template: '<input ng-if="showJobTitleFilter" data-placeholder="{{jobTitleSelectPlaceholder}}" style="width: 100%;" ui-select2="jobTitleFilterConfig" multiple ng-model="filterModel.jobTitles" class="full-width"></input>'
        });
    }
])
.directive('jvSchoolFilter', [
    'createFilter','i18n','$timeout',
    function(createFilter, i18n, $timeout) {
        return createFilter({
            link: function(scope) {
            var url = '../../action/application/search/facet?fieldId=schools';
            scope.schoolSelectPlaceholder = i18n['SELECT_SCHOOLS'];
            var maxResults = 20;
            function updateSummary() {
                var filterModel  = angular.copy(scope.filterModel);
                var summary = {
                    id: scope.filter.searchId,
                    hidden: scope.filter.hidden,
                    deleted: true
                };
                if(filterModel && filterModel.schools && filterModel.schools.length){
                    var schools = [];
                    angular.forEach(filterModel.schools,function(schoolObj,key){
                        schools.push(schoolObj.value);
                    });
                    summary.message = i18n['COMMON_SCHOOL']+': ' + schools.join(', ');
                    summary.deleted =  false;
                }
                scope.onSummaryChanged({ summary: summary });
            }
            //job title filter config
            scope.schoolFilterConfig = {
                    id:'value',
                    ajax : {
                        url : url,
                        quietMillis: 750,
                        data : function (term, page) {
                                result = {
                                    prefix: term,
                                    maxResults: maxResults,
                                    page: page - 1,
                            };
                            return result;
                        },
                        results: function (data, page) {
                            //pagination not supported by BE
                            //var more = (maxResults * page) < data.facetField.facetValues.count;
                            var more = false;
                            return {
                                results: data.facetField.facetValues,
                                more: more
                            };
                        }
                    },
                    formatResult: function (school) {
                        return '<strong>' + school.value + '</strong> ';
                    },
                    formatSelection: function (school) {
                            return school.value;
                    },
                    initSelection: function(element, callback) {
                        if(!$.isEmptyObject(scope.filterModel)){
                            var filterModelCopy = angular.copy(scope.filterModel);
                            scope.filterModel = {};
                            scope.filterModel = filterModelCopy;
                        }
                    }
                };
                //making sure config is ready before select2 renders
                $timeout(function(){
                    scope.showSchoolFilter = true;
                },300);

                var initSchoolFilterModel = function(){
                    scope.filterModel = {};
                };
                //todo fix the change event for range filter
                scope.$watch('filterModel',function(newVal, oldVal){
                    if(!newVal){
                        initSchoolFilterModel();
                    }
                    updateSummary();
                },true);
                scope.onFilterLoaded();
            },
            template: '<input ng-if="showSchoolFilter" data-placeholder="{{schoolSelectPlaceholder}}" style="width: 100%;" ui-select2="schoolFilterConfig" multiple ng-model="filterModel.schools" class="full-width"></input>'
        });
    }
])
.directive('jvCheckboxFilter', [
    'createFilter', 'i18n',
    function(createFilter, i18n) {
        return createFilter({
            link: function(scope) {
                var AMOUNT_VISIBLE = 4;
                scope.i18n = i18n;
                scope.state = {
                    amountVisible: AMOUNT_VISIBLE,
                    enableShowMore: (scope.filter.values ? scope.filter.values.length > AMOUNT_VISIBLE : false),
                    showingMore: false
                };

                function isEmpty() {
                    if(scope.filter.values) {
                        return scope.filter.values.every(function(value) {
                            return !scope.filterModel[value.key];
                        });
                    } else {
                        return true;
                    }
                }

                function updateSummary() {
                    var summary = {
                        id: scope.filter.searchId,
                        hidden: scope.filter.hidden,
                        deleted: scope.isEmpty
                    };
                    if (!summary.deleted) {
                        summary.message = scope.filter.name + ': ' + scope.filter.values.filter(function(value) {
                            return scope.filterModel[value.key];
                        }).map(function(value) {
                            return value.value;
                        }).join(', ');
                    }
                    scope.onSummaryChanged({ summary: summary });
                }

                scope.toggleAmount = function() {
                    scope.state.showingMore = !scope.state.showingMore;
                    if (scope.state.showingMore && scope.filter.values) {
                        scope.state.amountVisible = scope.filter.values.length;
                    }
                    else {
                        scope.state.amountVisible = AMOUNT_VISIBLE;
                    }
                }

                scope.$watch('filterModel', function(val) {
                    if (!val) {
                        scope.filterModel = {};
                    }
                    scope.isEmpty = isEmpty();
                    scope.state.any = scope.isEmpty;
                    updateSummary();
                }, true);
                scope.$watch('state.any', function(any) {
                    if (any && scope.filter.values) {
                        // reset selected
                        scope.filter.values.forEach(function(value) {
                            scope.filterModel[value.key] = false;
                        });
                    }
                });
                scope.onFilterLoaded();
            },
            template: '<div class="jv-checkbox-filter-group"><div class="margin-bottom-xx-small"><label><input type="checkbox" ng-model="state.any" ng-disabled="isEmpty" /> {{ i18n.ANY }}</label></div><div ng-repeat="value in filter.values | limitTo:state.amountVisible" class="margin-bottom-xx-small"><label><input type="checkbox" ng-model="filterModel[value.key]" value="1" /> {{ value.value }}</label></div><a href="" class="display-block" ng-if="state.enableShowMore" ng-click="toggleAmount()">{{ state.showingMore ? i18n.SHOW_LESS : i18n.SHOW_ALL }}</a></div>'
        });
    }
])
.directive('jvRangeFilter', [
    'createFilter',
    function(createFilter) {
        return createFilter({
            link: function(scope) {
                scope.$watch('filterModel', function(val) {
                    if (!val) {
                        scope.filterModel = {
                            low: scope.filter.options.floor,
                            high: scope.filter.options.ceil
                        }
                    }
                });
                scope.options = angular.extend({}, scope.filter.options, {
                    hidePointerLabels: true,
                    hideLimitLabels: true
                });
                scope.selection = function() {
                    if (!scope.filterModel) {
                        return;
                    }
                    var low = scope.filterModel.low;
                    var high = scope.filterModel.high;
                    var unit = scope.filter.unit;
                    if (low === high) {
                        return low + ' ' + (low === 1 ? unit.singular : unit.plural);
                    }
                    if (high === scope.options.ceil) {
                        high += '+';
                    }
                    return low + ' - ' + high + ' ' + (high === 1 ? unit.singular : unit.plural);
                }
                scope.onFilterLoaded();
            },
            template: '<div>{{ selection() }}</div><rzslider rz-slider-model="filterModel.low" rz-slider-high="filterModel.high" rz-slider-options="options"></rzslider>'
        });
    }
])

.factory('jvNumberRangeFilterTagFAC', function(){
    return function(){
        return '<div class="row"><div class="col-6 padding-none" ng-repeat="field in custom"><label class="block dark-tri">{{ field.label }}</label><input type="number" class="full-width" ng-model="filterModel[field.model]" /></div>';
    };
})

.directive('jvNumberRangeFilter', [
    'createFilter', 'i18n','jvNumberRangeFilterTagFAC',
    function(createFilter, i18n, jvNumberRangeFilterTagFAC) {
        return createFilter({
            link: function(scope) {

                function updateSummary(val) {
                    var summary = {
                        id: scope.filter.searchId,
                        hidden: scope.filter.hidden,
                        deleted: !val || scope.filterModel.min == null || scope.filterModel.max == null
                    }
                    if (!summary.deleted) {
                        summary.message = scope.filter.name + ': ' + scope.filterModel.min + ' - ' + scope.filterModel.max;
                    }
                    scope.onSummaryChanged({ summary: summary });
                }
                scope.custom = [
                    { model: 'min', label: i18n.MIN },
                    { model: 'max', label: i18n.MAX }
                ];
                scope.$watch('filterModel', function(val) {
                    if (!val) {
                        scope.filterModel = {};
                    }
                    scope.$watch('filterModel', updateSummary, true);
                });
                scope.onFilterLoaded();
            },
            template: jvNumberRangeFilterTagFAC()
        });
    }
])

.factory('currencyRangeAjaxSelectTagFAC', [function(){
    return function(ngModel, placeholder){
        return '<div jv-ajax-select jv-ajax-select-object jv-ajax-select-id="currencyCode" jv-ajax-select-no-pagination="false" jv-ajax-select-url="{{filter.url}}" jv-ajax-select-response-key="resultList" jv-ajax-select-text="displayName" jv-ajax-select-query-param-name="q" ng-model="{0}" jv-ajax-select-can-clear="false" jv-ajax-select-populate class="margin-bottom-xx-small full-width" jv-ajax-select-placeholder="{1}"></div>'.format(ngModel, placeholder);
    };
}])

.directive('jvCurrencyRangeFilter', ['createFilter', 'i18n','currencyRangeAjaxSelectTagFAC', 'jvNumberRangeFilterTagFAC',
    function(createFilter, i18n, currencyRangeAjaxSelectTagFAC, jvNumberRangeFilterTagFAC)
    {
        return createFilter({
            link: function(scope){
                scope.custom = [
                    {model: 'min', label: i18n.MIN},
                    {model: 'max', label: i18n.MAX}
                ];
                function updateSummary(val) {
                    var summary = {
                        id: scope.filter.searchId,
                        hidden: scope.filter.hidden,
                        deleted: !val || scope.filterModel.min == null || scope.filterModel.max == null
                    }
                    if (!summary.deleted) {
                        summary.message = scope.filter.name + ': ' + scope.filterModel.min + ' - ' + scope.filterModel.max;
                    }
                    scope.onSummaryChanged({ summary: summary });
                }
                scope.$watch('filterModel', function(val){
                    if(!val){
                        scope.filterModel = {};
                    }
                    scope.$watch('filterModel', updateSummary, true);
                });
                scope.onFilterLoaded();
            },
            template: '<div>{0}{1}</div>'.format(currencyRangeAjaxSelectTagFAC("filterModel['currency']", i18n.SELECT_CURRENCY), jvNumberRangeFilterTagFAC())
        });
    }])

.directive('jvLocationFilter', [
    'createFilter', '$window', '$timeout', 'i18n',
    function(createFilter, $window, $timeout, i18n) {
        return createFilter({
            link: function(scope, element) {
                scope.types = [
                    { value: 1, label: i18n.WITHIN_RANGE },
                    { value: 2, label: i18n.OUTSIDE_RANGE }
                ];
                scope.ranges = [
                    { value: 5, label: i18n.I18N_DISTANCE_5+' '+i18n[_jvselfUser.locale.unitOfDistance] },
                    { value: 10, label: i18n.I18N_DISTANCE_10+' '+i18n[_jvselfUser.locale.unitOfDistance] },
                    { value: 25, label: i18n.I18N_DISTANCE_25+' '+i18n[_jvselfUser.locale.unitOfDistance] },
                    { value: 50, label: i18n.I18N_DISTANCE_50+' '+i18n[_jvselfUser.locale.unitOfDistance] },
                    { value: 100, label: i18n.I18N_DISTANCE_100+' '+i18n[_jvselfUser.locale.unitOfDistance] }
                ];
                // internationalLocationEnabled is checked on the backend and the filter is not sent to the UI if this feature is disabled.

                if (typeof properties !== 'undefined' && properties.locationAPIKey && !window.locationAPIInitialized) {
                    jQuery.ajax({
                        url: 'https://maps.googleapis.com/maps/api/js?key=' + properties.locationAPIKey,
                        dataType: 'script',
                        success: function(data, textStatus, jqxhr) {
                            if (jqxhr.status == 200) {
                                window.locationAPIInitialized = true;
                                setUpLocationFilter();
                            }
                        },
                        async: true
                    });
                }

                function updateSummary(val) {
                    var summary = {
                        id: scope.filter.searchId,
                        hidden: scope.filter.hidden,
                        deleted: (!val || !val.location)
                    };
                    var distance;
                    var type;
                    if (!summary.deleted) {
                        distance = scope.ranges.filter(function(d) {
                            return (val.distance === d.value);
                        }).pop().label;
                        type = scope.types.filter(function(t) {
                            return (val.type === t.value);
                        }).pop().label;
                        summary.message = distance + ' ' + type + ' ' + val.location;
                    }
                    scope.onSummaryChanged({ summary: summary });
                }

                var setUpLocationFilter = function() {
                    if (!$window.google || !$window.google.maps) {
                        return;
                    }
                    var geo = new $window.google.maps.Geocoder();
                    var autocompleteElement = element.find('[jv-location-autocomplete]');

                    autocompleteElement.select2(angular.extend({
                        query: function(query) {
                            geo.geocode({
                                address: query.term
                            }, function(location, status){
                                var results = [];
                                if (location) {
                                    results = location.map(function(item){
                                        return {
                                            id: item.formatted_address,
                                            text: item.formatted_address,
                                            geoObj: item
                                        };
                                    });
                                }
                                query.callback({
                                    results: results
                                });
                            });
                        },
                        initSelection: function(element, callback) {
                            var val = element.val();
                            callback({id: val, text: val});
                        },
                        allowClear: true,
                        minimumInputLength: 1,
                        placeholder: i18n.ENTER_ZIP_OR_CITY
                    }, ($window._jvPluginDefaults && $window._jvPluginDefaults.select2) || {})).on('change', function(event) {
                        $timeout(function() {
                            var location;
                            scope.filterModel = scope.filterModel || {};
                            if (event.added) {
                                location = event.added.geoObj.geometry.location;
                                scope.filterModel.latitude = location.lat();
                                scope.filterModel.longitude = location.lng();
                            }
                            else {
                                scope.filterModel.latitude = null;
                                scope.filterModel.longitude = null;
                            }
                            scope.filterModel.location = event.val;
                        });
                    });
                    scope.$watch('filterModel.type', function(val) {
                        if (scope.filterModel && !scope.filterModel.distance) {
                            // select default distance in ui
                            scope.filterModel.distance = 5;
                        }
                        if (!val) {
                            // reset when all locations is selected
                            scope.filterModel = { type: val };
                            if (parseFloat(jQuery.fn.jquery) <= 1.3) {
                                autocompleteElement.val('').change();
                            } else {
                                autocompleteElement.val('').trigger('change');
                            }
                        }
                    });
                    scope.$watch('filterModel', function(val) {
                        if (val) {
                            autocompleteElement.select2('val', scope.filterModel.location);
                        }
                        else {
                            autocompleteElement.select2('val', null);
                        }
                    });
                    scope.$watch('filterModel', updateSummary, true);
                };
                if(window.locationAPIInitialized){
                	setUpLocationFilter();
                }
                scope.onFilterLoaded();
            },
            template: '<select simple-select="{ allowClear: true, placeholder: \'' + i18n.ANY + '\' }" ng-model="filterModel.type" ng-options="o.value as o.label for o in types" class="full-width"><option></option></select><div ng-show="filterModel.type"><input type="hidden" jv-location-autocomplete style="width: 100%" class="margin-top-x-small" /><select ng-model="filterModel.distance" ng-options="o.value as o.label for o in ranges" class="margin-top-x-small jv-select-miles"></select></div>'
        });
    }
])
.directive('jvDateRangeFilter', [
    'createFilter', 'i18n', '$rootScope', '$filter', '$timeout',
    function(createFilter, i18n, $rootScope, $filter, $timeout) {

        return createFilter({
            link: function(scope, element) {
                var saveFormat = 'YYYY-MM-DD';
                scope.types = [
                    { value: 1, label: i18n.PAST_7_DAYS },
                    { value: 2, label: i18n.PAST_MONTH },
                    { value: 3, label: i18n.PAST_3_MONTHS }
                ];
                if (scope.filter.enableFutureOptions) {
                    scope.types.push(
                      { value: 4, label: i18n.NEXT_7_DAYS },
                      { value: 5, label: i18n.NEXT_30_DAYS },
                      { value: 6, label: i18n.NEXT_90_DAYS });
                }
                scope.types.push({ value: 'custom', label: i18n.CUSTOM_RANGE });
                scope.custom = [
                    {
                        model: 'from',
                        label: i18n.FROM,
                        datepicker: {
                            onClose: function() {
                                $timeout(function() {
                                    // timeout for datepicker, without this it will
                                    // not update first field on blur
                                    if (!scope.filterModel.to) {
                                        element.find('[jv-locale-datepicker]')[1].focus();
                                    }
                                }, 200, false);
                            }
                        }
                    },
                    { model: 'to', label: i18n.TO, datepicker: {} }
                ];

                function updateSummary(val) {
                    var summary = {
                        id: scope.filter.searchId,
                        hidden: scope.filter.hidden,
                        deleted: !val || !scope.filterModel.from || !scope.filterModel.to
                    }
                    if (!summary.deleted) {
                        summary.message = scope.filter.name + ': ';
                        if (val.type === 'custom') {
                            summary.message += $filter('localeDateTime')(scope.filterModel.from, 'shortDate', 'MM/dd/yyyy', true) + ' - ' + $filter('localeDateTime')(scope.filterModel.to, 'shortDate', 'MM/dd/yyyy', true);
                        }
                        else {
                            summary.message += scope.types.filter(function(type) {
                                return (scope.filterModel.type === type.value);
                            }).pop().label;
                        }
                    }
                    scope.onSummaryChanged({ summary: summary });
                }

                function getDateRange(type) {
                    var today = $rootScope.fetchTodayInUsersTimeZone();
                    var range = { to: moment(today).format(saveFormat),
                                  from: moment(today).add(1, 'days').format(saveFormat)};
                    switch (type) {
                        case 1:
                            range.from = moment(today).subtract(6, 'days').format(saveFormat);
                            break;
                        case 2:
                            range.from = moment(today).subtract(29, 'days').format(saveFormat);
                            break;
                        case 3:
                            range.from = moment(today).subtract(89, 'days').format(saveFormat);
                            break;
                        case 4:
                            range.to = moment(today).add(7, 'days').format(saveFormat);
                            break;
                        case 5:
                            range.to = moment(today).add(30, 'days').format(saveFormat);
                            break;
                        case 6:
                            range.to = moment(today).add(90, 'days').format(saveFormat);
                            break;
                    }
                    return range;
                }

                scope.showRangePicker = function() {
                    if (!scope.filterModel) {
                        return;
                    }
                    return (scope.filterModel.type === 'custom');
                };

                scope.handleUserTypeChange = function() {
                    var dateRange;
                    //this check returns false either when the directive has no on-filter-change or
                    //when the controller has no onFilterChange method
                    if(angular.isDefined(scope.onFilterChange())){
                        //filterChange has to be set to false for custom range as the watch should be fired only after
                        //the To date has been selected
                        var filterChange = scope.filterModel.type === 'custom' ? false : true;
                        scope.onFilterChange({"setValue":filterChange});
                    }
                    if (scope.filterModel.type === 'custom') {
                        scope.filterModel.from = moment($rootScope.fetchTodayInUsersTimeZone()).format(saveFormat);
                        scope.filterModel.to = null;
                        $timeout(function() {
                            // timeout for datepicker, without this it will
                            // change the second field instead of the first
                            element.find('[jv-locale-datepicker]')[0].focus();
                        }, 10);
                    }
                    else if (scope.filterModel.type) {
                        dateRange = getDateRange(scope.filterModel.type);
                        scope.filterModel.to = dateRange.to;
                        scope.filterModel.from = dateRange.from;
                    }
                };
                scope.handleFieldFocus = function(field) {
                    if (field.model === 'to' && scope.filterModel.from && !scope.filterModel.to) {
                        scope.filterModel.to = moment($rootScope.fetchTodayInUsersTimeZone()).format(saveFormat);
                    }
                };
                scope.$watch('filterModel.type', function(val) {
                    if (scope.filterModel && val == null) {
                        scope.filterModel.from = null;
                        scope.filterModel.to = null;
                    }
                });
                scope.$watch('filterModel.from', function(val) {
                    // prevent user from selecting earlier 'to' date
                    if (val) {
                        scope.custom[1].datepicker.minDate = moment(val, saveFormat).toDate();
                    }
                    else {
                        scope.custom[1].datepicker.minDate = null;
                    }
                });
                scope.$watch('filterModel.to', function(val) {
                    // prevent user from selecting later 'from' date
                    if (val) {
                        scope.custom[0].datepicker.maxDate = moment(val, saveFormat).toDate();
                    }
                    else {
                        scope.custom[0].datepicker.maxDate = null;
                    }
                });
                scope.$watch('filterModel', updateSummary, true);
                scope.onFilterLoaded();
            },
            template:   '<select simple-select="{ allowClear: true, placeholder: \'' + i18n.ANY + '\' }" ng-model="filterModel.type" ng-options="o.value as o.label for o in types" class="full-width" ng-change="handleUserTypeChange()"><option></option></select>' +
                        '<div ng-show="showRangePicker()" class="margin-top-x-small row">' +
                            '<div class="col-6 padding-none" ng-repeat="field in custom">' +
                                '<label class="block dark-tri">{{ field.label }}</label>' +
                                '<input type="text" jv-locale-datepicker="field.datepicker" class="full-width" ng-model="filterModel[field.model]" ng-focus="handleFieldFocus(field)" />' +
                            '</div>' +
                        '</div>'
        });
    }
])
.directive('jvRequisitionFilter', [
    'createFilter', 'i18n', '$localStorage', '$interpolate', '$http',
    function(createFilter, i18n, $localStorage, $interpolate, $http) {
        return createFilter({
            link: function(scope) {
                scope.types = scope.filter.values.filter(function(type) {
                    // remove All Reqs option, empty placeholder will take its place
                    return (type.value !== 0);
                });
                scope.recentReqs = $localStorage.candSearchRecentReqs || [];
                scope.page = 0;

                function addReqOption(req) {
                    var option = {
                        value: req,
                        key: reqName(req.reqName, req.reqId)
                    };
                    var existingOption = scope.recentReqs.filter(function(type) {
                        return (type.value && type.value.reqEId === req.reqEId);
                    }).pop();
                    if (existingOption) {
                        scope.filterModel = existingOption.value;
                        return existingOption;
                    }
                    scope.recentReqs.unshift(option);
                    if (scope.recentReqs.length > 4) {
                        // limit to 4 most recent
                        scope.recentReqs.pop();
                    }
                    $localStorage.candSearchRecentReqs = scope.recentReqs;
                    return option;
                }

                function updateSummary(val) {
                    var summary = {
                        id: scope.filter.searchId,
                        hidden: scope.filter.hidden,
                        deleted: val == null
                    }
                    if (!summary.deleted) {
                        if (val.reqEId) {
                            summary.message = reqName(val.reqName, val.reqId);
                        }
                        else {
                            summary.message = scope.types.filter(function(type) {
                                return (type.value === val);
                            }).pop().key;
                        }
                    }
                    scope.onSummaryChanged({ summary: summary });
                }

                function reqName(title, id) {
                    var idLabel = '';
                    if (id && id.trim()) {
                        idLabel = ' (' + id.trim() + ')';
                    }
                    return title + idLabel;
                }

                function reqLabel(item) {
                    if (!item.value.secondaryLocations) {
                        item.value.secondaryLocations = [];
                    }
                    return $interpolate(
                        '<div class="padding-xx-small">' +
                            '<div class="font-medium ellipsis" title="{{ item.key }}">{{ item.key }}</div>' +
                            '<div class="req-filter-meta-data small font-roman ellipsis">' +
                                '{{ item.value.category }}' +
                                (item.value.category && item.value.primaryLocation ? ' - ' : '') +
                                (item.value.primaryLocation ? '{{ item.value.primaryLocation }}' : '') +
                                (item.value.secondaryLocations.length > 0 ? ' ' + i18n.N_MORE : '') +
                            '</div>' +
                        '</div>')({ item: item, count: item.value.secondaryLocations.length });
                }

                function getReqs(query, page) {
                    scope.loading = true;
                    page = page || 0;
                    return $http.get(jvUrls.jhire + '/action/requisitions', { params: {
                        page: page,
                        maxResults: 10,
                        jobStateValue: 1009,
                        prefix: query
                    }}).then(function(response) {
                        if (response.data.jobs) {
                            scope.config.searchView.list = scope.config.searchView.list.concat(transformReqs(response.data.jobs));
                        }
                        scope.total = response.data.jobCount;
                        scope.page = page;
                    }).finally(function() {
                        scope.loading = false;
                    });
                }

                function transformReqs(reqs) {
                    return reqs.map(function(job) {
                        return {
                            key: reqName(job.title, job.requisitionId),
                            value: {
                                reqEId: job.EId,
                                reqId: job.requisitionId,
                                reqName: job.title,
                                primaryLocation: (job.location) ? job.location.name : '',
                                secondaryLocations: job.jobLocations || [],
                                category: (job.category) ? job.category.name : ''
                            }
                        };
                    });
                }

                scope.selectRequisition = function() {
                    var data = {
                        filterByReqModal: true
                    };
                    scope.$emit('showAddToReqModal', data);
                    scope.$broadcast('hideTypeahead');
                };

                scope.getInitialReqs = function(query) {
                    scope.config.searchView.list = [];
                    return getReqs(query);
                };

                scope.scrollReqs = function(query) {
                    if (scope.loading) {
                        return;
                    }
                    if (scope.total > scope.config.searchView.list.length) {
                        return getReqs(query, scope.page + 1);
                    }
                };

                scope.$on('AddReqModalDataSent', function(event, data) {
                    scope.filterModel = addReqOption(data).value;
                });

                scope.$watch('filterModel', function(val) {
                    if (val && val.reqName) {
                        addReqOption(val);
                    }
                    updateSummary(val);
                });

                scope.config = {
                    initialView: {
                        cols: [
                            {
                                header: i18n.SELECT_REQ_STATUS,
                                list: scope.types,
                                listLabel: function(item) {
                                    return $interpolate('<div class="padding-xx-small">{{ item.key }}</div>')({ item: item });
                                }
                            },
                            {
                                header: i18n.MOST_RECENT_REQUISITIONS,
                                list: scope.recentReqs,
                                listLabel: reqLabel
                            }
                        ]
                    },
                    searchView: {
                        header: i18n.SUGGESTED_ACTIVE_REQUISITIONS,
                        list: [],
                        listLabel: reqLabel
                    },
                    label: function() {
                        var selectedItem;
                        if (scope.filterModel) {
                            selectedItem = scope.recentReqs.concat(scope.types).filter(function(type) {
                                return (type.value === scope.filterModel);
                            }).pop();
                            if (selectedItem && selectedItem.key) {
                                return selectedItem.key;
                            }
                        }
                        return i18n.ANY;
                    },
                    property: 'value'
                }

                scope.onFilterLoaded();
            },
            template: '<div jv-typeahead="config" on-search="getInitialReqs(query)" on-scroll-end="scrollReqs(query)" model="filterModel" class="jv-req-filter">' +
                            '<header class="row margin-bottom-x-small">' +
                                '<div class="col-6 padding-none">' +
                                    '<em class="dark-sec">' + (typeof properties !== 'undefined' && properties.trackSearch ? i18n.OFCCP_LIST_MODAL_TEXT : '') + '&nbsp;</em>' +
                                '</div>' +
                                '<div class="col-6 padding-none text-right">' +
                                    '<a href ng-click="selectRequisition()" class="font-roman">' + i18n.ADVANCED_REQUISITION_SEARCH + '</a>' +
                                '</div>' +
                            '</header>' +
                      '</div>' +
                      '<a class="block margin-top-small font-roman small" href="" ng-click="selectRequisition()">' + i18n.ADVANCED_REQUISITION_SEARCH + '</a>'
        });
    }
])
.directive('jvCollectionFilter', [
    'createFilter', 'i18n',
    function(createFilter, i18n) {
        return createFilter({
            link: function(scope) {
                scope.i18n = i18n;

                function updateSummary(val) {
                    var summary = {
                        id: scope.filter.searchId,
                        hidden: scope.filter.hidden,
                        deleted: !val
                    }
                    if (!summary.deleted) {
                        summary.message = scope.filter.name + ': ' + scope.filterModel.name;
                    }
                    scope.onSummaryChanged({ summary: summary });
                }

                scope.setCollection = function(item) {
                    scope.filterModel = {
                        EId: item.EId,
                        name: item.name
                    };
                };
                scope.removeCollection = function() {
                    scope.filterModel = undefined;
                };
                scope.$watch('filterModel', updateSummary);
                scope.onFilterLoaded();
            },
            template: '<a href="" ng-show="!filterModel" ng-click="state.modals.collectionList = true">{{ i18n.SELECT_COLLECTION }}</a><span ng-show="filterModel" class="tag full-width"><a href="" ng-click="removeCollection()" class="tag-remove margin-top-xx-small float-right"><i class="icon icon-close"></i></a>{{ filterModel.name }}</span><div jv-search-collection-list-modal show="state.modals.collectionList" hide="state.modals.collectionList = false" on-select="setCollection(item)"></div>'
        });
    }
])
.directive('jvSourceFilter', [
    'createFilter', 'i18n', '$http', '$timeout',
    function(createFilter, i18n, $http, $timeout) {
        return createFilter({
            link: function(scope, element) {
                var oldFilter;
                scope.types = [];
                scope.jobBoards = [];
                scope.sourceDetail = {};
                // add initial value so it doesn't get cleared out
                // before the types are loaded
                if (scope.filterModel) {
                    if (typeof scope.filterModel === 'string') {
                        // old filter used to be a string
                        oldFilter = scope.filterModel;
                        scope.filterModel = {};
                    }

                    if (scope.filterModel.ids) {
                        scope.types = scope.filterModel.ids.map(function(val) {
                            return { EId: val, name: '' };
                        });
                    }

                    if (scope.filterModel.subtype) {
                        scope.jobBoards.push({ name: scope.filterModel.subtype });
                    }
                }

                var sourceKinds = {
                    Referral: { category: 'people' },
                    EmployeeEntered: { category: 'people' },
                    EnteredForEmployee: { category: 'people' },
                    Agency: { category: 'people', fieldId: '-21' },
                    JobBoard: { category: 'jobBoard' },
                    EnteredByRecruiter: { category: 'people', fieldId: '-16' },
                    EnteredByHiringManager: { category: 'people', fieldId: '-17' },
                    Custom: { category: 'subType' },
                    CustomWithName: { category: 'text' },
                    Email: { category: 'text' }
                };
                var request = $http.get(jvUrls.jhire + '/action/application/sourceTypes').then(function(response) {
                    if (response.data.sourceTypes) {
                        scope.types = response.data.sourceTypes;
                        if (oldFilter) {
                            scope.types.some(function(type) {
                                if (type.name === oldFilter) {
                                    scope.filterModel.type = type.EId;
                                    return true;
                                }
                            });
                        }
                        $timeout(function() {
                            element.find('select').eq(0).trigger('change');
                        });
                    }
                });
                var jobBoardsInitialized = false;

                function updateSummary(val) {
                    var summary = {
                        id: scope.filter.searchId,
                        hidden: scope.filter.hidden,
                        deleted: !val || (Array.isArray(val.ids) && !val.ids.length)
                    };
                    var label = '';
                    if (!summary.deleted) {
                        if (val && Array.isArray(val.ids)) {
                            label = scope.types.filter(function(option) {
                                return val.ids.some(function (filterOption) {
                                    return option.EId === filterOption;
                                });
                            }).map(function(option) {
                                return option.name;
                            }).join(', ');
                            summary.message = scope.filter.name + ': ' + label;
                            if (val.person) {
                                summary.message += ' (' + val.person.fullName + ')';
                            }
                            if (val.subtype) {
                                summary.message += ' (' + val.subtype + ')';
                            }
                        } else if(angular.isString(val)){
                            //This is when single source is passed as parameters eq: dashboard
                            scope.types.forEach(function(option) {
                                if(val === option.name){
                                    summary.ids = [option.EId];
                                    summary.message = val;
                                    scope.filterModel = summary;
                                }
                            });
                        }
                    }
                    // Modified the condition - as it was not resetting source while resetAll functionality
                    // if(angular.isDefined(val)){
                        scope.onSummaryChanged({ summary: summary });
                    // }
                }

                function getSubtypeConfig(typeId) {
                    var type = scope.types.filter(function(t) {
                        return (t.EId === typeId);
                    }).pop();
                    return angular.extend({}, sourceKinds[type.kind], type);
                }

                function getJobBoards() {
                    return $http.get(jvUrls.jhire + '/action/requisition/form/createJobLinkSource').then(function(response) {
                        if (response.data.sourceType) {
                            scope.jobBoards = response.data.sourceType;
                            $timeout(function() {
                                element.find('select').eq(1).trigger('change');
                            });
                            jobBoardsInitialized = true;
                        }
                    });
                }

                scope.employeeUrl = function() {
                    if (scope.subtype && scope.subtype.fieldId) {
                        return jvUrls.admin + '/action/user/search?fieldId=' + scope.subtype.fieldId;
                    }
                };

                scope.$watch('filterModel.ids', function(val, prev) {
                    //If filterModel has changed and there is only one source selected, populate subType
                    //and second dropdown..
                    if (val && val.length === 1) {
                        request.then(function() {
                            scope.subtype = getSubtypeConfig(val[0]);
                            if (scope.subtype.category === 'jobBoard' && !jobBoardsInitialized) {
                                jobBoardsInitialized = true;
                                getJobBoards();
                            }
                        });
                    //else clean up data, so that it does not get sent in the next search call.
                    } else {
                        if (scope.filterModel) {
                            scope.filterModel.subtype = null;
                            scope.filterModel.person = null;
                        }
                        scope.subtype = null;
                    }
                });

                scope.$watch('filterModel', function(val) {
                    request.then(function() {
                        updateSummary(val);
                    });
                }, true);

                scope.onFilterLoaded();
            },
            template: '<select simple-select="{ allowClear: true, placeholder: \'' + i18n.ANY + '\' }" multiple ng-model="filterModel.ids" ng-options="o.EId as o.name for o in types" class="full-width margin-bottom-x-small"><option></option></select>' +
                      // employee selector
                      '<input ng-if="subtype.category == \'people\'" jv-employee-select ng-model="filterModel.person" type="hidden" jv-employee-select-obj jv-employee-select-allow-clear jv-employee-select-url="{{ employeeUrl() }}" data-placeholder="' + i18n.ANY + '" style="width:100%" />' +
                      // custom text
                      '<input type="text" ng-if="subtype.category == \'text\'" ng-model="filterModel.subtype" class="full-width" placeholder="{{ subtype.promptText }}" />' +
                      // custom dropdown
                      '<div ng-if="subtype.category == \'subType\'"><select simple-select="{ allowClear: true, placeholder: \'' + i18n.ANY + '\' }" ng-model="filterModel.subtype" ng-options="o.name as o.name for o in subtype.sourceTypes" class="full-width"><option></option></select></div>' +
                      // job board
                      '<div ng-if="subtype.category == \'jobBoard\'"><select simple-select="{ allowClear: true, placeholder: \'' + i18n.ANY + '\' }" ng-model="filterModel.subtype" ng-options="o.name as o.name for o in jobBoards" class="full-width"><option></option></select>'});
    }
])
.directive('jvEmployeeFilter', [
    'createFilter', 'i18n',
    function(createFilter, i18n) {
        return createFilter({
            link: function(scope) {
                scope.i18n = i18n;

                function updateSummary(val) {
                    var summary = {
                        id: scope.filter.searchId,
                        hidden: scope.filter.hidden,
                        deleted: !val || !val.length
                    };
                    if (!summary.deleted) {
                        summary.message = scope.filter.name + ': ' + scope.filterModel.map(function(employee) {
                            return employee.fullName;
                        }).join(', ');
                    }
                    scope.onSummaryChanged({ summary: summary });
                }

                scope.$watch('filterModel', updateSummary);
                scope.onFilterLoaded();
            },
            template: '<input ng-hide="filter.hidden" jv-employee-select="multiple" ng-model="filterModel" type="hidden" jv-employee-select-obj style="width:100%" />'
        });
    }
]);
